module.exports = __webpack_public_path__ + "media/images/dogs_images/black-mouth-cur.jpg";